import RequestError from "./RequestError";
export function getRequestData() {
    return window['requestData'];
}
class Auth {
    constructor(params) {
        this.auth_endpoint = params.auth_endpoint;
    }
    async login(email, password, csrfKey, csrfValue) {
        let body = Auth.formData();
        body.append('email', email);
        body.append('password', password);
        if (csrfKey && csrfValue) {
            body.append(csrfKey, csrfValue);
        }
        return this.request('login', body);
    }
    async signup(email, password, csrfKey, csrfValue) {
        let body = Auth.formData();
        body.append('mail', email);
        body.append('password', password);
        body.append('response_type', 'code');
        if (csrfKey && csrfValue) {
            body.append(csrfKey, csrfValue);
        }
        return this.request('signup', body);
    }
    async autoSignup(service, response_type, domain) {
        let body = Auth.formData();
        body.append('service', service);
        body.append('response_type', response_type);
        body.append('domain', 'domain');
        return this.rawRequest('reg-auto', body);
    }
    async passwordReset(email, csrfKey, csrfValue) {
        let body = Auth.formData();
        body.append('email', email);
        if (csrfKey && csrfValue) {
            body.append(csrfKey, csrfValue);
        }
        return this.request('reset-password', body);
    }
    async savePassword(password, token, csrfKey, csrfValue) {
        let body = Auth.formData();
        body.append('password', password);
        body.append('resetToken', token);
        if (csrfKey && csrfValue) {
            body.append(csrfKey, csrfValue);
        }
        return this.request('save-password', body);
    }
    static formData() {
        return new FormData();
    }
    static formBasicData() {
        return this.formData();
    }
    rawRequest(endpoint, body) {
        return fetch(endpoint, {
            method: 'POST',
            credentials: 'include',
            body: body
        })
            .then(response => {
            return response.json();
        })
            .then(response => {
            if (response.status !== 'ok') {
                throw new RequestError(response.message, response);
            }
            return response;
        });
    }
    request(endpoint, body) {
        return fetch(`${this.auth_endpoint}${endpoint}`, {
            method: 'POST',
            credentials: 'include',
            body: body
        })
            .then(response => {
            return response.json();
        })
            .then(response => {
            if (response.status !== 'ok') {
                throw new RequestError(response.message, response);
            }
            return response;
        });
    }
}
export default Auth;
